import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import bellIcon from "../../shared/assets/icons/bell.png";
import profileIcon from "../../shared/assets/icons/profile.png";
import profileHome from "../../shared/assets/icons/profileHome.png";
import dashboardIconOne from "../../shared/assets/icons/dashboardiconone.png";
import rightIcon from "../../shared/assets/icons/rightDashboard.png";
import requestIcon from "../../shared/assets/icons/request_web.png";
import logoIcon from "../../shared/assets/icons/logo-web.png";
import homeIcon from "../../shared/assets/icons/homess.png";
import equipment from "../../shared/assets/icons/equip_web.png";
import maintenance from "../../shared/assets/icons/maintenance.png";
import { dashboardService } from "./services/dashboardService";
import DataTableGrid from "../../shared/components/DataTableGrid";
import { Chart } from "react-google-charts";
import {
  STATUS_WORK_COMPLETED,
  STATUS_WORK_HOLD,
  getStatusName,
} from "../../shared/constants/statusConstants";
import { formatDateString } from "../../shared/utils/dateFormatter";
import { BsQrCodeScan } from "react-icons/bs";
import { GoHomeFill } from "react-icons/go";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { FiSettings } from "react-icons/fi";
import { TbBellRinging, TbInvoice } from "react-icons/tb";
import {
  MdOutlineAssignment,
  MdAutorenew,
  MdCheckCircle,
  MdPendingActions,
  MdCancel,
  MdOutlineKeyboardArrowRight,
  MdPayment,
} from "react-icons/md";

import { useNavigate } from "react-router-dom";
import StatusGridCards from "../../shared/components/StatusGridCards";
import MobileFooterNav from "../../shared/components/MobileFooterNav";
import HeaderNav from "../../shared/components/HeaderNav";
import DashboardCharts from "../../shared/components/DashboardCharts";
import EquipmentChart from "../../shared/components/EquipmentChart";
import WorkOrderChart from "../../shared/components/WorkOrderChart";
import EquipmentListChart from "../../shared/components/EquipmentListChart";
import QrScannerModal from "../../shared/components/QrScannerModal";
const Dashboard = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook

  const [inProgressCount, setinProgressCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [completeCount, setCompleteCount] = useState(0);
  const [unScheduledCount, setUnScheduledCount] = useState(0);
  const [pendingApprovalCount, setPendingApprovalCount] = useState(0);
  const [amcActiveCount, setAmcActiveCount] = useState(0);
  const [amcExpiredCount, setAmcExpiredCount] = useState(0);
  const [nonAmcCount, setNonAmcCount] = useState(0);
  const [todayTasks, setTodaysTasks] = useState([]);
  const [equipmentDatas, setEquipmentDatas] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [totalServiceRequests, setTotalServiceRequests] = useState(0);
  const tasksPerPage = 10;
  const itemsPerPage = 10;

  const getPriorityLabel = (priorityCode) => {
    const priorityMap = {
      0: "Low",
      1: "Medium",
      2: "Normal",
      3: "High",
      4: "Urgent",
    };
    return priorityMap[priorityCode] || "N/A";
  };
  const getContractTypeLabel = (contractCode) => {
    const contractMap = {
      0: "PAID",
      1: "UNDER WARRANTY",
      3: "AMC",
    };
    return contractMap[contractCode] || "N/A";
  };
  useEffect(() => {
    const fetchDashboardCounts = async () => {
      try {
        const countsData = await dashboardService.fetchDashboardCounts();
        if (countsData.success && Array.isArray(countsData.data)) {
          countsData.data.forEach(item => {
            switch (item.title) {
              case 'Total Service Request':
                setTotalServiceRequests(item.count || 0);
                break;
              case 'Ongoing':
                setinProgressCount(item.count || 0);
                break;
              case 'Completed':
                setCompleteCount(item.count || 0);
                break;
              case 'Pending':
                setPendingCount(item.count || 0);
                break;
              case 'Reject':
                setUnScheduledCount(item.count || 0);
                break;
              case 'Equipments':
                setAmcActiveCount(item.amc_count || 0);
                setNonAmcCount(item.non_amc_count || 0);
                // AMC expired is not provided, keep it 0 or calculate if needed
                setAmcExpiredCount(0);
                break;
              default:
                break;
            }
          });
        }
      } catch (error) {
        console.error('Error fetching dashboard counts:', error);
      }
    };

    fetchDashboardCounts();

    const fetchTasks = async () => {
      try {
        const data = await dashboardService.fetchMaintenanceRequests("-id");
        if (data.success) {
          // Change this line - use data.data instead of data.maintenance_requests
          const formattedTasks = data.data.map((item) => ({
            id: item.id,
            wo_no: item.id,
            req_id: item.org_task_code ?? "N/A",
            equipment: item.equipment_name,
            schedule_start: formatDateString(item.reported_time),
            schedule_end: item.reported_time,
            status: getStatusName(item.status),
            priority: getPriorityLabel(item.priority),
            technician: item.first_name
              ? `${item.first_name} ${item.last_name}`
              : "N/A",
            description: item.notes || item.issues,
          }));
          setTasks(formattedTasks);
          setTodaysTasks(formattedTasks);
          setTotalItems(formattedTasks.length);
        }
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    };
    fetchTasks();

    const fetchEquipmentDatas = async (page = 1) => {
      setLoading(true);
      try {
        const data = await dashboardService.fetchEquipment(page);
        // Change: data.equipments to data.data
        if (data.success && Array.isArray(data.data)) {
          const formattedData = data.data.map((item) => ({
            serialNo: item.serial_number || item.serial_identifier, // Use actual field names
            name: item.serial_identifier, // Equipment name
            category: item.category,
            make: item.make,
            model: item.model,
            contractType: getContractTypeLabel(item.contract_type),
            address: item.address1 || "N/A", // Use address1 from API
            fullAddress:
              `${item.address1 || ""}${item.address2 ? ", " + item.address2 : ""}${item.city ? ", " + item.city : ""}`.trim() ||
              "N/A",
            customerId: item.customer_id,
            companyName: item.company_name,
            equipmentId: item.equipment_id,
            itemId: item.item_id,
          }));
          setEquipmentDatas(formattedData);
          setTotalItems(formattedData.length);
          setAddresses(
            Array.from(
              new Set(
                formattedData
                  .map((item) => item.address)
                  .filter((addr) => addr && addr !== "N/A"),
              ),
            ),
          );
        }
      } catch (error) {
        console.error("Error fetching equipment:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEquipmentDatas();
  }, []);


  // charts
  const data = [
    ["Task", "Hours per Day"],
    ["Completed", 11],
    ["Ongoing", 2],
    ["Pending", 2],
  ];

  const options = {
    title: "Work Orders",
    pieHole: 0.4,
    is3D: false,
  };

  return (
    <div>
      {showScanner && (
        <QrScannerModal
          onClose={() => setShowScanner(false)}
          onScan={(text) => {
            setShowScanner(false);
            try {
              const url = new URL(text);
              window.location.href = url.href;
            } catch {
              window.location.href = text;
            }
          }}
        />
      )}
      <div className="mobile-dashboard-new">
        {/*Greeting Header */}
        <HeaderNav profileIcon={profileIcon} />

        {/* Quick Actions Card */}
        <div className="action-card">
          <div className="action-bg-shape"></div>
          {/* Desktop Rotating Settings Icon */}
          <div className="desktop-settings-icon">
            <FiSettings />
          </div>
          <div className="action-content">
            <h3 className="action-title">
              <span className="desktop-hidden">Scan or </span>Manually Register
              <span className="action-subtitle mobile-hidden">
                {" "}
                your Requirements Instantly
              </span>
            </h3>

            {/* Mobile Buttons */}
            <div className="hero-action-buttons desktop-hidden">
              <button
                className="action-btn primary"
                onClick={() => setShowScanner(true)}
              >
                <span className="btn-icon">
                  <BsQrCodeScan />
                </span>
                Scan
              </button>

              <div className="vertical-divider"></div>

              <button
                className="action-btn outline"
                onClick={() => navigate("/maintenance")}
              >
                Register
              </button>
            </div>

            {/* Desktop Only Button */}
            <div className="desktop-register">
              <button
                className="action-btn primary"
                // onClick={() => navigate("/equipment")}
                onClick={() => navigate("/maintenance")}
              >
                Register
              </button>
            </div>
          </div>
        </div>
        {pendingApprovalCount > 0 && (
          <section
            onClick={() => navigate("/tasklist?status=24,32")}
            style={{ cursor: "pointer" }}
          >
            <div className="work-approval-grid">
              <div className="work-counter">
                <span>{pendingApprovalCount}</span>
              </div>
              <div className="work-approval-text">
                <h3>Pending Work Approvals</h3>
              </div>
              <div className="work-approval-icon">
                <MdOutlineKeyboardArrowRight />
              </div>
            </div>
          </section>
        )}
        {/* Today's Tasks */}
        {/* <section className="task-section-new">
          <div className="section-header">
            <h3>Overview</h3>
            <span
              className="section-header"
              onClick={() => navigate("/tasklist")}
            >
              {/* Last 30 Days */}
        {/* </span>
          </div>

          {todayTasks.slice(0, 5).map((task, idx) => (
            <div className="task-card-new" key={idx} onClick={() => navigate(`/maintenancedetails/${task.id}`)} style={{ cursor: 'pointer' }}>
              <div className="task-row">
                <h4>{task.technician}</h4>
                <span className="req-id">#{task.req_id}</span>
              </div>

              <div className="task-row">
                <span className="task-date">{task.schedule_start}</span>
                <span className={`status-pill ${task.status}`}>
                  {task.status}
                </span>
              </div>
            </div>
          ))}
        </section> */}
        <section className="overview-section">
          {/* Row 1 */}
          <div className="overview-row two-column">
            <StatusGridCards
              title="Total Service Request"
              count={totalServiceRequests}
              bgColor="#ffffff"
              Icon={MdOutlineAssignment}
              iconColor="#004eba"
              onClick={() => navigate("/tasklist")}
            />
            <StatusGridCards
              title="Ongoing"
              count={inProgressCount}
              bgColor="#f4f4f4"
              Icon={MdAutorenew}
              iconColor="#00b8d8"
              onClick={() => navigate('/tasklist?ongoing=true')}
            />
          </div>
          {/* Row 2 */}
          <div className="overview-row three-column">
            <StatusGridCards
              title="Completed"
              count={completeCount}
              bgColor="#F6FAF6"
              Icon={MdCheckCircle}
              iconColor="#008b25"
              onClick={() => navigate(`/tasklist?status=${STATUS_WORK_COMPLETED}`)}
            />
            <StatusGridCards
              title="Work On Hold"
              count={pendingCount}
              bgColor="#fffbf4d8"
              Icon={MdPendingActions}
              iconColor="#e4be00"
              onClick={() => navigate(`/tasklist?status=14`)}
            />
            <StatusGridCards
              title="Reject"
              count={unScheduledCount}
              bgColor="#fff0f0"
              Icon={MdCancel}
              iconColor="#e53935"
              onClick={() => navigate('/tasklist?status=3')}
            />
          </div>
        </section>

        {/* charts */}

        {/* Charts Section - Responsive Flex Layout */}
        {
          false && (
            <section className="dashboard-charts-section">
              <div className="charts-responsive-container">
                {/* Work Order Chart */}
                <div className="chart-responsive-item">
                  <div className="chart-card">
                    <div className="chart-card-header">
                      <h3>
                        <span className="chart-icon">📋</span>
                        Work Order Status
                      </h3>
                      {/* <span className="chart-badge">Last 30 Days</span> */}
                    </div>
                    <div className="chart-responsive-wrapper">
                      <DashboardCharts
                        serviceStats={{
                          completed: completeCount,
                          pending: pendingCount,
                          ongoing: inProgressCount
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Equipment Chart */}
                <div className="chart-responsive-item">
                  <div className="chart-card">
                    <div className="chart-card-header">
                      <h3>
                        <span className="chart-icon">🔧</span>
                        Equipments
                      </h3>
                      <span className="chart-badge">
                        Total: {equipmentDatas.length || 1250}
                      </span>
                    </div>
                    <div className="chart-responsive-wrapper">
                      <EquipmentChart />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )
        }
        <div style={styles.container}>
          <div style={styles.item}>
            <WorkOrderChart
              stats={{
                completed: completeCount,
                ongoing: inProgressCount,
                pending: pendingCount,
              }}
            />
          </div>

          <div style={styles.item}>
            <EquipmentListChart
              data={{
                amcActive: amcActiveCount,
                amcExpired: amcExpiredCount,
                nonAmc: nonAmcCount,
              }}
            />
          </div>
        </div>

        {/* <hr className="hr-line"></hr> */}
        <section className="btn-sec-inline btn-sec-desktop">
          {/* All buttons in one row */}
          <button
            className="btn-sec-inline__btn btn-sec-inline__btn--primary"
            onClick={() => navigate("/equipmentlist")}
          >
            <span className="btn-sec-inline__icon"></span>Equipments
          </button>

          <button
            className="btn-sec-inline__btn btn-sec-inline__btn--text"
            onClick={() => navigate('/invoicelist')}
          >
            <span className="btn-sec-inline__icon">
              <TbInvoice />
            </span>{" "}
            Invoice
          </button>

          <button
            className="btn-sec-inline__btn btn-sec-inline__btn--text"
            onClick={() => navigate('/payment-history')}
          >
            <span className="btn-sec-inline__icon">
              <MdPayment />
            </span>{" "}
            Payments
          </button>

        </section>
        {/* Floating Bottom Nav */}
        <div>
          <MobileFooterNav />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

const styles = {
  container: {
    display: "flex",
    gap: "20px",
    width: "100%",
    flexWrap: "wrap", // allows wrapping
  },

  item: {
    flex: "1 1 48%", // 2 columns
  },
};